import _Vue from 'vue';

import prepareEnvForHost from '@/HostApp/environment';

import initFW from '@/Framework/main';
import prepareEnv from '@/Common/Environment';
import { setIsDev } from '@/Common/Utils/Dev/deprecate';

import { baseApiUrl, defaultStyleSheetsURLs, serverProps } from '@/Common/Environment/const';
import hostServices from '@/HostApp/services';

// initialize hostApp with FW and render viewport
async function startHostApp(): Promise<void> {
	const Vue = _Vue;

	const { locale, devMode } = serverProps;

	const configVue = {
		devtools: serverProps.devMode
	};

	const optionsEnv: Partial<Host.IInitFWWithEnvOptions> = {
		locale,
		configVue,
		Vue,
		isHost: true,
		isHostDevMode: devMode
	};

	prepareEnv(optionsEnv);
	prepareEnvForHost(Vue);

	const hostApp = (await import(/* webpackMode: "eager" */ '@/HostApp/main')).default;

	const optionsFW: Partial<Host.IInitFWOptions> = {
		Vue,
		baseApiUrl,
		stylesheetUrls: defaultStyleSheetsURLs,
		transport: hostServices.httpServiceModule
	};

	initFW(optionsFW);
	setIsDev(devMode);

	return hostApp.renderViewport();
}

// Initialize FW with env to use without HostApp: testing, local dev App and UIKit
function init({
	Vue = _Vue,
	configVue = {},
	transport,
	isTest = false,
	// Standalone mode
	t,
	locale,
	baseApiUrl,
	stylesheetUrls,
	isLocalDev = false,
	isHostDevMode = false
}: Partial<Host.IInitFWWithEnvOptions> = {}): typeof _Vue {
	const optionsFWStandalone = { baseApiUrl, stylesheetUrls };
	const optionsEnvStandalone = { t, locale };
	const optionsFW = { Vue, transport, isTest, ...optionsFWStandalone };
	const optionsEnv = { Vue, configVue, ...optionsEnvStandalone, isLocalDev, isHostDevMode };

	prepareEnv(optionsEnv);

	return initFW(optionsFW);
}

export { startHostApp, init };

// Util modules
export * from '@/Common/Utils/General/Modules/all';
export * from '@/Common/Utils/General';

//Business special helpers
export * from '@/Common/Utils/General/Modules/special';

// Runtime utils
export * from '@/Common/Runtime';

// Framework utils
export * from '@/Framework/main';

// legacy adapter
export * from '@/Framework/adapter';
